import { createTheme } from '@mui/material/styles';
import { blue, orange, pink, green } from '@mui/material/colors';

// or
const theme = createTheme({
    palette: {
        primary: {
            main: blue[700]
        },
        info: {
            main: "#5bc0de",
            light: "#46b8da",
            dark: "#00a5d6",
        }
    },
    typography: {
        "fontFamily": `"Kanit", "Helvetica", "Kanit", sans-serif`,
        "fontSize": 14,
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.189) 0px 5px 15px",
                    ...(ownerState.disabled && {
                        backgroundColor: "#E9E8E8",
                    }),
                }),
                input: ({ ownerState }) => ({
                    color: '#4a4a4a',
                    backgroundColor: "rgba(255,255,255,0.95)",
                    borderRadius: "10px",
                    padding: "9px 10px",
                    ...(ownerState.disabled && {
                        backgroundColor: "#E9E8E8",
                    }),
                }), multiline: {
                    backgroundColor: "rgba(255,255,255,0.95)",
                    padding: 0,
                    input: {
                        padding: "4px",
                    }
                }
            }
        }, MuiAutocomplete: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                    backgroundColor: "rgba(255,255,255,0.95)",
                },
                input: ({ ownerState }) => ({
                    color: '#4a4a4a',
                    backgroundColor: "rgba(255,255,255,0.95)",
                    borderRadius: "10px",
                    ...(ownerState.disabled && {
                        backgroundColor: "#E9E8E8",
                    }),
                })

            }
        }, MuiFormControl: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    borderRadius: "20px",
                    backgroundColor: "rgba(255,255,255,0.95)",
                    ...(ownerState.disabled && {
                        backgroundColor: "#E9E8E8",
                    }),
                }),
            }
        }, MuiButtonBase: {
            styleOverrides: {
                root: {
                    zIndex: 1
                },
            }
        }
    },

});
export default theme;